<template>
    <div class="message-push-page">
        <!-- 筛选卡片 -->
        <el-card shadow="always" class="filter-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <i class="el-icon-message"></i>
                    <span>学生签到</span>
                    <el-divider direction="vertical"></el-divider>
                    <span class="header-sub">为学生签到打卡，签到后将自动推送微信通知给家长</span>
                </div>
            </div>
            <el-form :inline="true" :model="query" class="filter-form">
                <el-form-item label="年级">
                    <el-select clearable v-model="query.gradeId" placeholder="全部年级" style="width: 150px" @change="onGradeChange">
                        <el-option v-for="item in gradeList" :key="item.id" :label="item.gradeName" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="班级">
                    <el-select clearable v-model="query.classId" placeholder="请先选择年级" style="width: 150px" :disabled="!query.gradeId">
                        <el-option v-for="item in filteredClassList" :key="item.id" :label="item.className" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="姓名">
                    <el-input clearable v-model="query.nickname" placeholder="学生姓名" style="width: 130px"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input clearable v-model="query.phone" placeholder="手机号" style="width: 130px"></el-input>
                </el-form-item>
                <el-form-item label="学号">
                    <el-input clearable v-model="query.studentNo" placeholder="学号" style="width: 120px"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                    <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </el-card>

        <!-- 表格卡片 -->
        <el-card shadow="always" class="table-card">
            <div slot="header" class="card-header">
                <div class="card-header-left">
                    <span>学生列表</span>
                    <span class="total-badge">共 <b>{{ total }}</b> 条 | 已选 <b>{{ selectedIds.length }}</b> 人</span>
                </div>
                <div class="card-header-right">
                    <el-checkbox v-model="selectAll" @change="handleSelectAll" :indeterminate="isIndeterminate">全选</el-checkbox>
                    <el-date-picker v-model="signDate" type="date" placeholder="今日" :value-format="'yyyy-MM-dd'"
                    style="width: 160px; margin-right: 10px" size="small" disabled></el-date-picker>
                    <el-button type="success" icon="el-icon-check" :disabled="selectedIds.length === 0"
                        @click="handleBatchSignIn" :loading="signingLoading">
                        批量签到 ({{ selectedIds.length }})
                    </el-button>
                </div>
            </div>
            <!-- 签到统计 -->
            <div class="stats-bar">
                <div class="stat-item">
                    <span class="stat-label">学生总数</span>
                    <span class="stat-value total">{{ todayStatsData.totalStudents }}</span>
                    <span class="stat-unit">人</span>
                </div>
                <el-divider direction="vertical"></el-divider>
                <div class="stat-item">
                    <span class="stat-label">已签到</span>
                    <span class="stat-value signed">{{ todayStatsData.signedCount }}</span>
                    <span class="stat-unit">人</span>
                </div>
                <el-divider direction="vertical"></el-divider>
                <div class="stat-item">
                    <span class="stat-label">未签到</span>
                    <span class="stat-value unsigned">{{ todayStatsData.unsignedCount }}</span>
                    <span class="stat-unit">人</span>
                </div>
                <el-divider direction="vertical"></el-divider>
                <div class="stat-item">
                    <span class="stat-label">签到率</span>
                    <span class="stat-value rate">{{ todayStatsData.rate }}%</span>
                </div>
            </div>
            <el-table ref="table" :data="sortedList" border stripe v-loading="tableLoading"
                element-loading-text="加载中..." style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55" align="center"
                    :selectable="checkSelectable"></el-table-column>
                <el-table-column type="index" label="序号" width="70" align="center"/>
                <el-table-column prop="studentNo" label="学号" width="100" align="center"/>
                <el-table-column prop="nickname" label="姓名" min-width="100" show-overflow-tooltip/>
                <el-table-column prop="gradeName" label="年级" width="80"/>
                <el-table-column prop="className" label="班级" width="80"/>
                <el-table-column prop="phone" label="手机号" width="130" show-overflow-tooltip/>
                <el-table-column label="今日状态" width="130" align="center">
                    <template slot-scope="scope">
                        <template v-if="todayStatusMap[scope.row.id] && todayStatusMap[scope.row.id].signed">
                            <el-tag type="warning" size="small" effect="dark">已签到</el-tag>
                        </template>
                        <template v-else>
                            <el-tag type="info" size="small" effect="plain">未签到</el-tag>
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button v-if="canSign(scope.row)" type="primary" size="mini" icon="el-icon-check"
                            @click="handleSingleSignIn(scope.row)">签到</el-button>
                        <el-button v-else type="info" size="mini" icon="el-icon-check" disabled
                            title="该学生今日已签到">已签到</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 16px; text-align: right">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background>
                </el-pagination>
            </div>
        </el-card>

        <!-- 签到结果弹窗 -->
        <el-dialog title="签到结果" :visible.sync="resultDialogVisible" width="650px" :close-on-click-modal="false">
            <div v-if="signResult" style="text-align: center; margin-bottom: 20px">
                <el-result :icon="signResult.failCount === 0 ? 'success' : 'warning'"
                    :title="'签到完成'"
                    :subTitle="'成功 ' + signResult.successCount + ' 人' + (signResult.failCount > 0 ? ('，失败 ' + signResult.failCount + ' 人') : '')">
                </el-result>
                <p style="color: #909399; font-size: 13px">消息正在异步推送中，请稍后在推送日志中查看结果</p>
            </div>
            <el-table v-if="signResult && signResult.details" :data="signResult.details" border stripe size="small" max-height="300">
                <el-table-column prop="studentName" label="学生" width="100"/>
                <el-table-column prop="status" label="状态" width="80" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.status === 'SUCCESS' ? 'success' : 'danger'" size="small">
                            {{ scope.row.status === 'SUCCESS' ? '成功' : '失败' }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="reason" label="备注" show-overflow-tooltip/>
                <el-table-column label="推送" width="120" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.parentCount === 0" style="color: #909399">未绑定家长</span>
                        <span v-else>
                            成{{ scope.row.pushSuccessCount }}/败{{ scope.row.pushFailCount }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer">
                <el-button type="primary" @click="resultDialogVisible = false; fetchList()">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { reqListSysUsers } from '@/api/system/users'
import signInApi from '@/api/education/sign-in'
import { reqGradeList } from '@/api/education/grade'
import { reqClassList } from '@/api/education/class'

export default {
    name: 'MessagePush',
    data() {
        return {
            query: {
                gradeId: null, classId: null, nickname: '', phone: '', studentNo: ''
            },
            list: [],
            total: 0,
            pageNum: 1,
            pageSize: 20,
            tableLoading: false,
            signingLoading: false,
            gradeList: [],
            allClassList: [],
            signDate: new Date().toISOString().slice(0, 10),
            selectedIds: [],
            selectAll: false,
            isIndeterminate: false,
            todayStatusMap: {},
            signResult: null,
            resultDialogVisible: false,
            todayStatsData: { signedCount: 0, unsignedCount: 0, totalStudents: 0, rate: 0 }
        }
    },
    computed: {
        filteredClassList() {
            if (!this.query.gradeId) return []
            return this.allClassList.filter(c => c.gradeId === this.query.gradeId)
        },
        sortedList() {
            return [...this.list].sort((a, b) => {
                // 1. 未签到在前(0)，已签到在后(1)
                const aSigned = this.todayStatusMap[a.id] && this.todayStatusMap[a.id].signed ? 1 : 0
                const bSigned = this.todayStatusMap[b.id] && this.todayStatusMap[b.id].signed ? 1 : 0
                if (aSigned !== bSigned) return aSigned - bSigned
                // 2. 按年级正序
                const aGrade = a.gradeId || 0
                const bGrade = b.gradeId || 0
                if (aGrade !== bGrade) return aGrade - bGrade
                // 3. 按学号正序
                const aNo = a.studentNo || ''
                const bNo = b.studentNo || ''
                return aNo.localeCompare(bNo, undefined, { numeric: true })
            })
        }
    },
    created() {
        this.loadGradeClass()
    },
    methods: {
        async loadGradeClass() {
            try {
                const gradeRes = await reqGradeList()
                this.gradeList = gradeRes || []
                const classRes = await reqClassList()
                this.allClassList = classRes || []
            } catch (e) {
                console.error('加载年级班级失败', e)
            }
        },
        onGradeChange() {
            this.query.classId = null
        },
        handleSearch() {
            this.pageNum = 1
            this.fetchList()
        },
        handleReset() {
            this.query = { gradeId: null, classId: null, nickname: '', phone: '', studentNo: '' }
            this.pageNum = 1
            this.fetchList()
        },
        async fetchList() {
            this.tableLoading = true
            try {
                const res = await reqListSysUsers({
                    currentPage: this.pageNum,
                    pageSize: this.pageSize,
                    gradeId: this.query.gradeId || undefined,
                    classId: this.query.classId || undefined,
                    nickname: this.query.nickname || undefined,
                    phone: this.query.phone || undefined,
                    studentNo: this.query.studentNo || undefined,
                    roleMark: 'STUDENT'
                })
                this.list = res.records || []
                this.total = res.total || 0
                this.selectAll = false
                this.isIndeterminate = false
                // 查询今日签到统计和状态
                this.fetchTodayStats()
                if (this.list.length > 0) {
                    this.fetchTodayStatus()
                }
            } catch (e) {
                console.error('查询失败', e)
                this.$message.error('查询失败')
            } finally {
                this.tableLoading = false
            }
        },
        async fetchTodayStatus() {
            const ids = this.list.map(item => item.id)
            try {
                const res = await signInApi.todayStatusBatch(ids)
                this.todayStatusMap = res || {}
            } catch (e) {
                console.error('获取签到状态失败', e)
            }
        },
        async fetchTodayStats() {
            try {
                const res = await signInApi.todayStats({
                    gradeId: this.query.gradeId || undefined,
                    classId: this.query.classId || undefined,
                    nickname: this.query.nickname || undefined,
                    phone: this.query.phone || undefined,
                    studentNo: this.query.studentNo || undefined
                })
                this.todayStatsData = res || { signedCount: 0, unsignedCount: 0, totalStudents: 0, rate: 0 }
            } catch (e) {
                console.error('获取签到统计失败', e)
            }
        },
        canSign(row) {
            const status = this.todayStatusMap[row.id]
            return !status || !status.signed
        },
        checkSelectable(row) {
            return this.canSign(row)
        },
        handleSelectionChange(selection) {
            this.selectedIds = selection.map(s => s.id)
            this.selectAll = this.selectedIds.length === this.list.length && this.list.length > 0
            this.isIndeterminate = this.selectedIds.length > 0 && this.selectedIds.length < this.list.length
        },
        handleSelectAll(val) {
            if (val) {
                const selectable = this.list.filter(row => this.canSign(row))
                selectable.forEach(row => this.$refs.table.toggleRowSelection(row, true))
            } else {
                this.$refs.table.clearSelection()
            }
        },
        async handleSingleSignIn(row) {
            try {
                await this.$confirm(`确认对 "${row.nickname || row.studentNo}" 进行签到吗？`, '签到确认', {
                    confirmButtonText: '确认签到',
                    cancelButtonText: '取消',
                    type: 'info'
                })
            } catch {
                return
            }
            try {
                const res = await signInApi.batchSignIn({
                    studentIds: [row.id],
                    signDate: this.signDate,
                    signType: 'SIGN_IN'
                })
                this.signResult = res
                this.resultDialogVisible = true
                if (res && res.successCount > 0) {
                    this.todayStatusMap[row.id] = { signed: true }
                    this.fetchTodayStats()
                    this.$refs.table.toggleRowSelection(row, false)
                }
            } catch (e) {
                console.error('签到失败', e)
                this.$message.error('签到失败')
            }
        },
        async handleBatchSignIn() {
            if (this.selectedIds.length === 0) {
                this.$message.warning('请选择学生')
                return
            }
            // 二次确认
            try {
                await this.$confirm(`确认对选中的 ${this.selectedIds.length} 名学生进行签到吗？`, '批量签到确认', {
                    confirmButtonText: '确认签到',
                    cancelButtonText: '取消',
                    type: 'info'
                })
            } catch {
                return
            }

            this.signingLoading = true
            try {
                const res = await signInApi.batchSignIn({
                    studentIds: this.selectedIds,
                    signDate: this.signDate,
                    signType: 'SIGN_IN'
                })
                this.signResult = res
                this.resultDialogVisible = true
                if (res && res.successCount > 0) {
                    this.$refs.table.clearSelection()
                    this.selectedIds = []
                    // 更新今日状态和统计
                    this.fetchTodayStats()
                    await this.fetchTodayStatus()
                }
            } catch (e) {
                console.error('批量签到失败', e)
                this.$message.error('批量签到失败')
            } finally {
                this.signingLoading = false
            }
        },
        handleSizeChange(val) {
            this.pageSize = val
            this.fetchList()
        },
        handleCurrentChange(val) {
            this.pageNum = val
            this.fetchList()
        }
    },
    mounted() {
        this.fetchList()
    }
}
</script>

<style scoped>
.message-push-page {
    padding: 16px;
}
.filter-card {
    margin-bottom: 16px;
}
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.card-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
}
.header-sub {
    font-size: 13px;
    color: #909399;
    font-weight: normal;
}
.total-badge {
    font-size: 13px;
    color: #909399;
    margin-left: 12px;
}
.total-badge b {
    color: #409EFF;
}
.filter-form {
    margin-bottom: 0;
}
.stats-bar {
    display: flex;
    align-items: center;
    padding: 12px 0;
    margin-bottom: 8px;
    border-bottom: 1px solid #EBEEF5;
}
.stat-item {
    display: flex;
    align-items: baseline;
    gap: 4px;
    padding: 0 16px;
}
.stat-label {
    font-size: 13px;
    color: #909399;
}
.stat-value {
    font-size: 22px;
    font-weight: 700;
}
.stat-value.signed {
    color: #67C23A;
}
.stat-value.unsigned {
    color: #E6A23C;
}
.stat-value.total {
    color: #909399;
}
.stat-value.rate {
    color: #409EFF;
}
.stat-unit {
    font-size: 13px;
    color: #909399;
}
</style>
